<script lang="ts" setup>

</script>

<template>
    <b>Prescriptions Components:</b>
    <div class="ms-2">
        <div>
            <RouterLink to="/prescriptions/Cmm/ePA/Questionnaire">CMM ePA Questionnaire</RouterLink>
        </div>
        <div>
            <RouterLink to="/prescriptions/Cmm/ePA/QuestionnaireAnswers">CMM ePA Answers</RouterLink>
        </div>
        <div>
            <RouterLink to="/prescriptions/Cmm/ePA/TestCases">CMM Test Cases</RouterLink>
        </div>        
    </div>
</template>